export enum ChangeDynamicType {
  Up = 'up',
  Down = 'down',
  Stable = 'stable',
}
